var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "FaceID_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Face-ID"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26353",
    "data-name": "Grupo 26353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26352",
    "data-name": "Grupo 26352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Corners"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Corner"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7398",
    "data-name": "Trazado 7398",
    d: "M4.114,21.943V13.029a8.775,8.775,0,0,1,8.914-8.914h8.914a2.057,2.057,0,0,0,0-4.114H13.029A12.888,12.888,0,0,0,0,13.029v8.914a2.057,2.057,0,0,0,4.114,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Corner-2",
    "data-name": "Corner",
    transform: "translate(80) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7399",
    "data-name": "Trazado 7399",
    d: "M4.114-21.943v8.914a8.775,8.775,0,0,0,8.914,8.914h8.914A2.057,2.057,0,0,1,24-2.057,2.057,2.057,0,0,1,21.943,0H13.029A12.888,12.888,0,0,1,0-13.029v-8.914A2.057,2.057,0,0,1,2.057-24,2.057,2.057,0,0,1,4.114-21.943Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Corner-3",
    "data-name": "Corner",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7400",
    "data-name": "Trazado 7400",
    d: "M4.114-21.943v8.914a8.775,8.775,0,0,0,8.914,8.914h8.914A2.057,2.057,0,0,1,24-2.057,2.057,2.057,0,0,1,21.943,0H13.029A12.888,12.888,0,0,1,0-13.029v-8.914A2.057,2.057,0,0,1,2.057-24,2.057,2.057,0,0,1,4.114-21.943Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Corner-4",
    "data-name": "Corner",
    transform: "translate(80 80) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7401",
    "data-name": "Trazado 7401",
    d: "M4.114,21.943V13.029a8.775,8.775,0,0,1,8.914-8.914h8.914a2.057,2.057,0,0,0,0-4.114H13.029A12.888,12.888,0,0,0,0,13.029v8.914a2.057,2.057,0,0,0,4.114,0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Eye",
    transform: "translate(21.754 28.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,2.143V7.86A2.075,2.075,0,0,0,2,10,2.075,2.075,0,0,0,4,7.86V2.143A2.075,2.075,0,0,0,2,0,2.075,2.075,0,0,0,0,2.143Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Eye-2",
    "data-name": "Eye",
    transform: "translate(54.737 28.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M0,2.143V7.86A2.075,2.075,0,0,0,2,10,2.075,2.075,0,0,0,4,7.86V2.143A2.075,2.075,0,0,0,2,0,2.075,2.075,0,0,0,0,2.143Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Mouth",
    d: "M25.932,59.083A19.964,19.964,0,0,0,40,64.561a19.964,19.964,0,0,0,14.068-5.479A2.105,2.105,0,0,0,51.2,56,15.76,15.76,0,0,1,40,60.351,15.76,15.76,0,0,1,28.8,56a2.105,2.105,0,0,0-2.873,3.078Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Nose",
    d: "M40,30.175V44.912a1.237,1.237,0,0,1-1.409,1.4h-1.4a2.105,2.105,0,1,0,0,4.21h1.4a5.414,5.414,0,0,0,5.619-5.614V30.175a2.105,2.105,0,0,0-4.21,0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceId);
export default __webpack_public_path__ + "static/media/faceID.c8004548943b7b2e61dc7692e106709f.svg";
export { ForwardRef as ReactComponent };